module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst noChangePlaceholderKey = (((model.config || {}).fields || {}).noChange || {}).placeholder || 'form.fields.passwordGenerator.noChange'\nconst noChangePlaceholder = __(noChangePlaceholderKey)\n%><div data-field-code=\"<%= model.fieldCode %>\"><%\n%><%- include('./toggle', { model: model.toggleModel || {} }) %><%\n%><div class=\"element<%- model.type === 'password' ? ' active' : '' %>\" data-type=\"password\"><%- include('./password', { model: { dataTEXT: model.password, fieldCode: \"password\", placeholder: __(model.config.fields.password.placeholderKey), config: model.config.fields.password || {} }}); %></div><%\n%><div class=\"element<%- model.type === 'generatePasswordOfLength' ? ' active' : '' %>\" data-type=\"generatePasswordOfLength\"><%- include('./nrOfElements', { model: { dataINT: model.generatePasswordOfLength, minDataINT: model.config.fields.generatePasswordOfLength.min || 1, maxDataINT: model.config.fields.generatePasswordOfLength.max, fieldCode: \"generatePasswordOfLength\", config: model.config.fields.generatePasswordOfLength || {} } }); %></div><%\n%><div class=\"element<%- !model.type || model.type === 'noChange' ? ' active' : '' %>\" data-type=\"noChange\"><%= noChangePlaceholder %></div><%\n%></div>"
  , __filename = "..\\..\\npm\\frontend-controller\\baseComponents\\form\\fields\\passwordGenerator.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const noChangePlaceholderKey = (((model.config || {}).fields || {}).noChange || {}).placeholder || 'form.fields.passwordGenerator.noChange'
const noChangePlaceholder = __(noChangePlaceholderKey)

    ; __line = 4
    ; __append("<div data-field-code=\"")
    ; __append(escapeFn( model.fieldCode ))
    ; __append("\">")
    ; 

    ; __line = 5
    ; __append( include('./toggle', { model: model.toggleModel || {} }) )
    ; 

    ; __line = 6
    ; __append("<div class=\"element")
    ; __append( model.type === 'password' ? ' active' : '' )
    ; __append("\" data-type=\"password\">")
    ; __append( include('./password', { model: { dataTEXT: model.password, fieldCode: "password", placeholder: __(model.config.fields.password.placeholderKey), config: model.config.fields.password || {} }}) )
    ; __append("</div>")
    ; 

    ; __line = 7
    ; __append("<div class=\"element")
    ; __append( model.type === 'generatePasswordOfLength' ? ' active' : '' )
    ; __append("\" data-type=\"generatePasswordOfLength\">")
    ; __append( include('./nrOfElements', { model: { dataINT: model.generatePasswordOfLength, minDataINT: model.config.fields.generatePasswordOfLength.min || 1, maxDataINT: model.config.fields.generatePasswordOfLength.max, fieldCode: "generatePasswordOfLength", config: model.config.fields.generatePasswordOfLength || {} } }) )
    ; __append("</div>")
    ; 

    ; __line = 8
    ; __append("<div class=\"element")
    ; __append( !model.type || model.type === 'noChange' ? ' active' : '' )
    ; __append("\" data-type=\"noChange\">")
    ; __append(escapeFn( noChangePlaceholder ))
    ; __append("</div>")
    ; 

    ; __line = 9
    ; __append("</div>")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=..\..\npm\frontend-controller\baseComponents\form\fields\passwordGenerator.ejs

}